<template>
  <v-card class="card-container">
    <v-dialog v-model="removeDialog" max-width="300">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            {{ $t('Tem certeza de que deseja excluir esta métrica?') }}
          </div>

          <v-btn
            :disabled="removeLoading"
            class="ma-1"
            color="grey"
            text
            @click="removeDialog = false"
          >
            Cancelar
          </v-btn>

          <v-btn
            :loading="removeLoading"
            class="ma-1"
            color="error"
            text
            @click="removeMetric"
          >
            Excluir
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>

    <v-dialog v-model="manageModal" max-width="500">
      <MetricManage
        :metricId="metricId"
        :key="manageModalKey"
        @close="manageModal = false"
        @confirm=";(manageModal = false), list()"
      />
    </v-dialog>

    <div class="main-toolbar mb-4">
      <div class="icon-back">
        <v-icon color="white" size="28">mdi-android-studio</v-icon>
      </div>

      <span class="main-toolbar-title"> Métricas de Calibração </span>

      <v-spacer></v-spacer>

      <v-btn
        class="primary-button"
        depressed
        @click="
          ;(manageModalKey = !manageModalKey),
            (metricId = null),
            (manageModal = true)
        "
      >
        Nova métrica
      </v-btn>
    </div>

    <v-data-table
      :headers="headers"
      :items="metrics"
      class="main-table"
      hide-default-footer
      :items-per-page="pageSize"
      :loading="loading"
      :header-props="headerProps"
    >
      <template #[`item.actions`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="#0F3565"
              class="ma-1"
              dark
              small
              depressed
              v-bind="attrs"
              v-on="on"
              @click="openEdit(item)"
            >
              <v-icon small>mdi-pencil-outline</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('Editar') }}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="error"
              class="ma-1"
              dark
              small
              depressed
              v-bind="attrs"
              v-on="on"
              @click="openRemoveModal(item)"
            >
              <v-icon small>mdi-trash-can-outline</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('Remover') }}</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <div class="pagination">
      <div class="item-pagination block-one">
        <v-menu bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="btn"
              depressed
              color="#C0C0C0"
              small
            >
              qtd: {{ pageSize }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(size, i) in sizes"
              :key="i"
              @click="pageSize = size"
            >
              <v-list-item-title>{{ size }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <div class="registros" v-if="pager.totalItensOnPage">
          <span>
            1 - {{ pager.totalItensOnPage }} de {{ pager.totalItems }}
          </span>
        </div>
      </div>

      <div class="item-pagination block-two">
        <v-pagination
          class="pagination-item"
          v-model="page"
          :length="pager.totalPages"
          :total-visible="3"
        ></v-pagination>
      </div>
    </div>
  </v-card>
</template>

<script>
import ApiService from '../../../../../services/ApiService'
import MetricManage from './manage'

export default {
  name: 'CalibrationV2Metric',

  components: {
    MetricManage,
  },

  data() {
    return {
      removeDialog: false,
      removeLoading: false,
      headers: [
        { text: '', align: 'center', value: '', sortable: false },
        { text: 'Métrica', align: 'center', value: 'name', sortable: false },
        { text: 'Unidade', align: 'center', value: 'unit', sortable: false },
        { text: '', align: 'center', value: 'actions', sortable: false },
      ],
      headerProps: {
        sortByText: 'Ordenar por',
      },
      sizes: [10, 25, 50],
      totalItems: 4,
      totalItensOnPage: 4,
      totalPages: 1,
      metrics: [],
      loading: false,
      apiService: new ApiService(),
      pager: {},
      search: '',
      page: 1,
      pageSize: 10,
      metricId: null,
      manageModal: false,
      manageModalKey: false,
    }
  },

  created() {
    this.list()
  },

  methods: {
    removeMetric() {
      this.removeLoading = true

      this.apiService
        .delete(`calibration/v2/metric/${this.metricId}`)
        .then(() => {
          this.removeLoading = false
          this.$toast.success('Métrica excluída com sucesso!')
          this.removeDialog = false
          this.list()
        })
        .catch(() => {
          this.removeLoading = false
        })
    },

    openRemoveModal(item) {
      this.metricId = item.id
      this.removeDialog = true
    },

    openEdit(item) {
      this.metricId = item.id
      this.manageModalKey = !this.manageModalKey
      this.manageModal = true
    },

    list() {
      this.loading = true

      const model = {
        search: this.search,
        page: this.page,
        pageSize: this.pageSize,
      }

      this.apiService
        .get('calibration/v2/metric/paginate', model)
        .then((response) => {
          this.metrics = response.content.data
          this.pager = response.content.pager
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
  },

  watch: {
    page() {
      this.list()
    },

    pageSize() {
      this.list()
    },
  },
}
</script>

<style></style>
